import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'ls-toggle-button',
  templateUrl: './toggle-button.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleButtonComponent),
      multi: true
    }
  ]
})
export class ToggleButtonComponent implements ControlValueAccessor {
  // tslint:disable-next-line:no-input-rename
  @Input('max')
  public maxSelected = -1;
  // tslint:disable-next-line:no-input-rename
  @Input('min')
  public minSelected = -1;
  @Input()
  public items: Array<ToggleOption>;
  @Input()
  public toggleFormControl: FormControl;

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  public writeValue(obj: any): void {
    if (Array.isArray(obj)) {
      this.items = obj;
    } else if (obj) {
      throw Error('ls-multi-select only accepts arrays as data');
    }
  }

  public isChecked(index: number): boolean {
    return this.items[index].checked;
  }

  public changeValue(index: number): void {
    if (this.maxSelected === 1) {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].checked = false;
      }
      this.items[index].checked = true;
    } else {
      this.items[index].checked = !this.items[index].checked;
    }
    this.propagateChange(this.items);
  }

  private propagateChange = (_: any): void => {
    _ = _;
  };
}

export interface ToggleOption {
  label: string;
  checked: boolean;
}
